export default __webpack_public_path__ + "static/media/IMG_5583.970a9f52.jpg";